export const ValidarStock = (entrada, form, reportes) => {
  let stock = 0;
  if (entrada["stock"] > 0 && entrada["stock"]) {
    stock = entrada["stock"];
    reportes.map((reporte) => {
      if (entrada["id"] == reporte.entradas_id) {
        stock = stock - reporte.cantidad;
      }
    });
  } else {
    stock = form.stock;
    reportes.map((reporte) => {
      if (reporte.fecha == form.fecha + " HORA: " + form.hora) {
        stock = stock - reporte.cantidad;
      }
    });
  }

  if (stock <= 0) {
    return false;
  }

  return true;
};
